/* склонение слов в зависимости от числа */
const createCountFormatter = ({ few, one, two }) => {
  const titles = [one, two, few]
  const cases = [2, 0, 1, 1, 1, 2]
  return function (num) {
    let number = Number(num)
    let result
    if (Number.isInteger(number)) {
      number = Math.abs(number)
      result = titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
    } else {
      result = titles[1]
    }
    return result
  }
};
//для поля
export const formatPeriodCount = createCountFormatter({
  few: "лет",
  one: "год",
  two: "года"
})
//для подписи под дисклеймером
export const formatPeriodCountInSum = createCountFormatter({
  few: " лет",
  one: " года",
  two: " лет"
})
export const formatMoneyCountInSum = createCountFormatter({
  few: " рублей",
  one: " рубля",
  two: " рублей"
})

// Функция для обновления градиента
function updateRange(range) {
  const value = parseFloat(range.value);
  const max = parseFloat(range.max);
  const min = parseFloat(range.min);
  // Проверка на ноль, чтобы избежать деления на ноль
  const normalizedValue = max > min ? (value - min) / (max - min) * 100 : 0;

  range.style.setProperty('--value', `${normalizedValue}%`);
}

function removeLeadingZeros(num) {
  return num.toString().replace(/^0+/, '') || '0';
}

window.addEventListener(`DOMContentLoaded`, () => {

  let calculator = document.querySelector('.js-calculator');
  let rangeInput = calculator.querySelectorAll('.js-calculator-input');

  rangeInput.forEach((item) => {

    const inputs = item.querySelectorAll('input');
    const rangeNum = inputs[0]; //текстовый
    const range = inputs[1]; //ползунок

    updateRange(range); // Устанавливаем начальное значение
// Добавляем обработчик события
    range.addEventListener('input', () => updateRange(range));

    new Inputmask({
      mask: "*{0,10}",
      placeholder: '',
      showMaskOnHover: false,
      autoUnmask: true,

      definitions: {
        '*': {
          validator: "[0-9 ]",
          casing: "lower"
        }
      },
    }).mask(inputs[0]);
    //Если покрутили ползунок то и цифру выводим соответствующую
    range.addEventListener(`input`, () => {
      if (range.valueAsNumber) {
        rangeNum.value = range.valueAsNumber;
      } else {
        let min = range.getAttribute('min')
        rangeNum.value = min
      }
      const rangeMax = range.getAttribute('max');
      if (range.getAttribute('max') == 10000000) {
        let step = range.value == 0 ? 10 : parseInt(rangeMax / range.value);
        if (step > 10) {
          step = 35000;
        } else if (step > 5) {
          step = 10000 + ((step - 5) * 5000);
        } else {
          step = 3000 + (step * 2000);
        }
        range.setAttribute('step', step);
      }
      rangeNum.value = rangeNum.value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
    });
    //Если вручную ввели цифру то и ползунок надо выставить правильно
    rangeNum.addEventListener(`input`, () => {
      let rangeMax = parseInt(range.max);
      let rangeNumValue = parseInt(rangeNum.value);

      if (rangeNumValue > rangeMax) {
        rangeNum.value = rangeMax;
      }
      range.value = rangeNum.value;
      updateRange(range); // Устанавливаем начальное значение
    });
    rangeNum.addEventListener(`change`, () => {
      let rangeMin = parseInt(range.min);
      let rangeNumValue = parseInt(rangeNum.value);

      if ((!rangeNumValue) || (rangeNumValue < rangeMin)) {
        range.value = rangeMin
        rangeNum.value = rangeMin.toString()
        // Вызов события input
        const inputEvent = new Event('input')
        rangeNum.dispatchEvent(inputEvent)
      } else {
        range.value = rangeNum.value
      }
      rangeNum.value = removeLeadingZeros(rangeNum.value)
      updateRange(range); // Устанавливаем начальное значение
    })
    //пересчёт общих итогов после каждого изменения
    inputs.forEach((input) => {
      input.addEventListener(`input`, () => {
        const endSum = calculator.querySelector('.js-end-sum');
        const accumulations = calculator.querySelectorAll('.js-accumulation');
        const accValue = Array.from(accumulations, x => "" + x.value.split(' ').join(''));
        // const sum = accValue.reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0);
        const sum = accValue.reduce((partialSum, a) => {
          // Проверяем, является ли a пустым значением
          if (a) {
            return parseInt(partialSum) + parseInt(a);
          }
          // Если a пустое, возвращаем partialSum без изменений
          return partialSum;
        }, 0);
        //поле сумма накоплений
        endSum.innerHTML = sum.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');

        const startSum = parseInt(calculator.querySelector('.js-start-sum').value.split(' ').join(''))
        const period = parseInt(calculator.querySelector('.js-period').value);
        const profit = parseInt(calculator.querySelector('.js-profit').value)/100;
        const payMonth = calculator.querySelector('.js-pay-month');

        const yearVisual = calculator.querySelector(`.js-year-visual`);
        yearVisual.innerHTML = formatPeriodCount(period);

        const rate = profit / 12;
        const nper = period * 12;

        const capitalisationPerMonth = Math.round(startSum * (Math.pow((1 + profit / 12), nper)), 1);
        const remainingSum = sum - capitalisationPerMonth;

        let resPayPerMonth = ((rate * (rate * Math.pow((1 + rate), nper) + remainingSum)) /
          (Math.pow((1 + rate), nper) - 1));
        //при отрицательной доходности
        if (rate === 0) {
          resPayPerMonth = remainingSum / nper;
        }

        if (resPayPerMonth < 0) {
          resPayPerMonth = 0;
        }
        //поле ежемесячного платежа
        payMonth.innerHTML = Math.round(resPayPerMonth).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        //выводим в последнем блоке с текстом все данные
        const finalBlock = calculator.querySelector('.js-sum-adv')
        if (finalBlock) {
          finalBlock.querySelector('.js-sum-sum').innerHTML = sum.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ') + formatMoneyCountInSum(sum);
          finalBlock.querySelector('.js-sum-year').innerHTML = period + formatPeriodCountInSum(period);
          finalBlock.querySelector('.js-sum-start').innerHTML = startSum + formatMoneyCountInSum(startSum);
          finalBlock.querySelector('.js-sum-profit').innerHTML = calculator.querySelector('.js-profit').value + '%';
          finalBlock.querySelector('.js-sum-capitalization').innerHTML = Math.round(resPayPerMonth).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ') + formatMoneyCountInSum(resPayPerMonth);
        }
      })
    })

    rangeNum.addEventListener(`focus`, () => {
      rangeNum.value = ("" + rangeNum.value).split(' ').join('');
    })
    rangeNum.addEventListener(`blur`, () => {
      rangeNum.value = rangeNum.value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    })
  })

  const blockHover = calculator.querySelector('.js-hover-important-info');
  let events = "click";
  if (window.innerWidth >= 1024) {
    events = "mouseover mouseout";
  }
  events.split(" ").forEach(function (e) {
    blockHover.addEventListener(e, () => {
      blockHover.parentElement.querySelector('.js-hover-block').classList.toggle('hidden-block')
    })
  })

  //Оперу очень сильно корёжит, лишь бы вставить свой стиль по умолчанию, даже css не перебивается
  let isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) {
    let ranges = document.querySelectorAll('input[type=range]');
    ranges.forEach(function (e) {
      e.style.background = '#EB5828';
      e.style['-webkit-appearance'] = 'none';
    })
  }
});
